import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Event from "./components/Events";
import Dana from "./components/Dana";
import Meditate from "./components/Meditate";
import DhammaTalks from "./components/DhammaTalks";
import Arama from "./components/Arama";
import Hermitage from "./components/Hermitage";
import Donations from "./components/Donations";
import Gallery from "./components/Gallery";

import History from "./components/inside-packs/History";
import Teacher from "./components/inside-packs/Teacher";
import Mvideo from "./components/inside-packs/Mvideo";
import Mission from "./components/inside-packs/Mission";
import Compliment from "./components/inside-packs/Compliment";
import Demonstration from "./components/inside-packs/Demonstration";
import EventNotification from "./components/inside-packs/EventNotification";
import DanaCalander from "./components/inside-packs/DanaCalander";
import PaymentForDana from "./components/inside-packs/PaymentForDana";
import Pirikara from "./components/inside-packs/Pirikara";
import DanaInstructions from "./components/inside-packs/DanaInstructions";
import Pindapatha from "./components/inside-packs/Pindapatha";
import DammaTalksOurTeahcer from "./components/inside-packs/DammaTalksOurTeahcer";
import VariusTeachers from "./components/inside-packs/VariusTeachers";
import AnnualSubscription from "./components/inside-packs/AnnualSubscription";
import BuildingFound from "./components/inside-packs/BuildingFound";
import HealthFounds from "./components/inside-packs/HealthFounds";
import LifeLongMembership from "./components/inside-packs/LifeLongMembership";
import Maintenance from "./components/inside-packs/Maintenance";
import SangaFound from "./components/inside-packs/SangaFound";
import AnnualArma from "./components/inside-packs/AnnualArma";
import CeramonyVideo from "./components/inside-packs/CeramonyVideo";
import SelectDay from "./components/inside-packs/SelectDay";
import Securespot from "./components/inside-packs/Securespot";
import ExternalRetreats from "./components/inside-packs/ExternalRetreats";
import GuestSpeaker from "./components/inside-packs/GuestSpeaker";
import Ordination from "./components/inside-packs/Ordination";
import EventCalendor from "./components/inside-packs/EventCalendor";
import Community from "./components/Community";
import Paritta from "./components/inside-packs/Paritta";
import ParittaInstructions from "./components/inside-packs/ParittaInstructions";
import DhammaSermons from "./components/inside-packs/DhammaSermons";
import Housepreparation from "./components/inside-packs/Housepreparation";
import Danaathome from "./components/inside-packs/Danaathome";
import Housepreparationfordana from "./components/inside-packs/Housepreparationfordana";
import FuneralRituals from "./components/inside-packs/FuneralRituals";
import HomeRequestFormParitta from "./components/Forms/HomeRequestFormParitta";
import AnnualCeremonies from "./components/inside-packs/AnnualCeremonies";
import RainRetreat from "./components/inside-packs/RainRetreat";
import KatinaInstruction from "./components/inside-packs/KatinaInstruction";
import DammaSermonsRequest from "./components/Forms/DammaSermonsRequest";
import DanaAtHome from "./components/Forms/DanaAtHome";
import Login from "./components/Login";
import Register from "./components/Register";
import Gilanpasa from "./components/inside-packs/Gilanpasa";
import AfternoonGilapasa from "./components/inside-packs/AfternoonGilapasa";
import ExternalRules from "./components/inside-packs/ExternalRules";
import OrganizerInstructions from "./components/inside-packs/OrganizerInstructions";
import InternalRetreats from "./components/inside-packs/InternalRetreats";
import ItemsToBring from "./components/inside-packs/ItemsToBring";
import TimeTable from "./components/inside-packs/TimeTable";
import InternalRules from "./components/inside-packs/InternalRules";
import SoloRetreat from "./components/inside-packs/SoloRetreat";
import ProtectedRoutes from "./utils/protectedRoutes";
import DashboardRoutes from "./utils/DashboardRoutes";
import OngoingProjects from "./components/inside-packs/OngoingProjects";
import FeaturePlans from "./components/inside-packs/FeaturePlans";
import MaintenanceHermitage from "./components/inside-packs/MaintenanceHermitage";
import PhotoGallery from "./components/inside-packs/PhotoGallery";
import DanaRequest from "./components/Forms/DanaRequest";
import GilanpasaRequest from "./components/Forms/GilanpasaRequest";
import DanaPaymentRequest from "./components/Forms/DanaPaymentRequest";
import PirikaraRequest from "./components/Forms/PirikaraRequest";
import ExternalRetreatPackenham from "./components/Forms/ExternalRetreatPackenham";
import ExternalRetreatHallam from "./components/Forms/ExternalRetreatHallam";
import ExternalRetreatGlen from "./components/Forms/ExternalRetreatGlen";
import GuestSpeakerOrgReq from "./components/Forms/GuestSpeakerOrgReq";
import AramaPoojaRequest from "./components/Forms/AramaPoojaRequest";
import LandLotRequest from "./components/Forms/LandLotRequest";
import FiveYearRequest from "./components/Forms/FiveYearRequest";
import MembershipForFiveYear from "./components/Forms/MembershipForFiveYear";
import OnGoingRequest from "./components/Forms/OnGoingRequest";
import FeaturePlanRequest from "./components/Forms/FeaturePlanRequest";
import MaintananceRequest from "./components/Forms/MaintananceRequest";
import BuildingFundRequest from "./components/Forms/BuildingFundRequest";
import LifelongMembershipForm from "./components/Forms/LifelongMembershipForm";
import AnnualMembershipForm from "./components/Forms/AnnualMembershipForm";
import SponseringKatina from "./components/inside-packs/SponseringKatina";
import KatinaRequest from "./components/Forms/KatinaRequest";
import InternalRetreatForm from "./components/Forms/InternalRetreatForm";
import InternalRetreatRequestForm from "./components/Forms/InternalRetreatRequestForm";
import GuestSpeakerRequest from "./components/Forms/GuestSpeakerRequest";
import SoloRetreatRegistrationForm from "./components/inside-packs/SoloRetreatRegistrationForm";
import SoloRetreatRequestForm from "./components/Forms/SoloRetreatRequestForm";
import OrdinationRegistration from "./components/Forms/OrdinationRegistration";
import OrdinationRequest from "./components/Forms/OrdinationRequest";
import ScrollToTop from "./Hook/ScrollToTop";
import ContactUs from "./components/ContactUs";
import GeneralForm from "./components/Forms/GeneralForm";
import InternalRetreatOrganiser from "./components/inside-packs/InternalRetreatOrganiser";
import DammaTalksPage from "./components/inside-packs/DammaTalksPage";
import VariousTeachersTalks from "./components/inside-packs/VariousTeachersTalks";
import OrganiserInstructions from "./components/inside-packs/OrganiserInstructions";
import OrgainserRegister from "./components/Forms/OrgainserRegister";
import MaintainRequest from "./components/Forms/MaintainRequest";
import SanghaHealthFundRequest from "./components/Forms/SanghaHealthFundRequest";
import LifeLongForm from "./components/Forms/LifeLongForm";
import SanghaFundForm from "./components/Forms/SanghaFundForm";
import AnnualFundForm from "./components/Forms/AnnualFundForm";

const App = () => {
  const [isCheckingToken, setIsCheckingToken] = useState(false);
  let intervalId = null;

  const checkTokenExpiration = () => {
    const expirationTime = localStorage.getItem("token_expiration");
    if (expirationTime) {
      const currentTime = new Date().getTime();
      if (currentTime > parseInt(expirationTime)) {
        // Token has expired, log the user out
        localStorage.removeItem("token");
        localStorage.removeItem("id");
        localStorage.removeItem("roles"); // Changed from user_type
        localStorage.removeItem("user_type"); // Keep for backward compatibility
        localStorage.removeItem("user_name");
        localStorage.removeItem("access_area");
        localStorage.removeItem("token_expiration");
        window.location.href = "/"; // Redirect to login page
      }
    }
  };

  // Set up token expiration check on component mount
  useEffect(() => {
    // Check token expiration every minute
    intervalId = setInterval(checkTokenExpiration, 60000); // 60000ms = 1 minute
    
    // Initial check on mount
    checkTokenExpiration();
    
    // Cleanup interval on component unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []); // Empty dependency array ensures this runs only once

  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/event" element={<Event />} />
        <Route path="/community" element={<Community />} />
        <Route path="/dana" element={<Dana />} />
        <Route path="/meditate" element={<Meditate />} />
        <Route path="/talks" element={<DhammaTalks />} />
        <Route path="/arama" element={<Arama />} />
        <Route path="/hermitage" element={<Hermitage />} />
        <Route path="/donations" element={<Donations />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<ContactUs />} />


        {/* routes for buttons */}
        <Route path="/history" element={<History />} />
        <Route path="/teacher" element={<Teacher />} />
        <Route path="/mvideo" element={<Mvideo />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/compliment" element={<Compliment />} />

        <Route path="/demonstration" element={<Demonstration />} />
        <Route path="/eventNotification" element={<EventNotification />} />
        <Route path="/eventcalendar" element={<EventCalendor />} />
        <Route path="/annualceremonies" element={<AnnualCeremonies />} />

        <Route path="/raintreat" element={<RainRetreat />} />
        <Route path="/katinaInstructions" element={<KatinaInstruction />} />
        <Route path="/sponseringKatina" element={<SponseringKatina />} />
        <Route path="/katinaRequest" element={<KatinaRequest />} />

        <Route path="/paritta" element={<Paritta />} />
        <Route path="/parittainstructions" element={<ParittaInstructions />} />
        <Route path="/dhammasermons" element={<DhammaSermons />} />
        <Route path="/housepreparation" element={<Housepreparation />} />
        <Route path="/danaathome" element={<Danaathome />} />
        <Route
          path="/housepreparationfordana"
          element={<Housepreparationfordana />}
        />
        <Route path="/funeralrituals" element={<FuneralRituals />} />

        {/* form */}
        <Route
          path="/homerequestformparitta"
          element={<HomeRequestFormParitta />}
        />
        <Route path="/dammaSermonsRequest" element={<DammaSermonsRequest />} />
        <Route path="/danaathomeform" element={<DanaAtHome />} />

        <Route path="/danaCalander" element={<DanaCalander />} />
        <Route path="/paymentfordana" element={<PaymentForDana />} />
        <Route path="/pirikara" element={<Pirikara />} />
        <Route path="/danaInstructions" element={<DanaInstructions />} />
        <Route path="/pindapatha" element={<Pindapatha />} />
        <Route path="/gilanpasa" element={<Gilanpasa />} />
        <Route path="/afternoon" element={<AfternoonGilapasa />} />
        <Route path="/danaRequest" element={<DanaRequest />} />
        <Route path="/gilanpasaRequest" element={<GilanpasaRequest />} />
        <Route path="/danaPaymentRequest" element={<DanaPaymentRequest />} />
        <Route path="/prikaraRequest" element={<PirikaraRequest />} />

        <Route path="/dammatalksteahcer" element={<DammaTalksOurTeahcer />} />
        <Route path="/variusteachers" element={<VariusTeachers />} />
        <Route path="/dammaTalksPage" element={<DammaTalksPage />} />
        <Route path="/variousTeachersTalk" element={<VariousTeachersTalks />} />



        <Route path="/annualsubscription" element={<AnnualSubscription />} />
        <Route path="/buldingfounds" element={<BuildingFound />} />
        <Route path="/healthfounds" element={<HealthFounds />} />
        <Route path="/lifelongmembership" element={<LifeLongMembership />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/sangafound" element={<SangaFound />} />

        <Route path="/buildingFundRequest" element={<BuildingFundRequest />} />
        <Route
          path="/liveLongMembershoipForm"
          element={<LifelongMembershipForm />}
        />
        <Route
          path="/annualMembershipForm"
          element={<AnnualMembershipForm />}
        />
         <Route path="/maintainRequest" element={<MaintainRequest />} />
         <Route path="/healthFundReq" element={<SanghaHealthFundRequest />} />
         <Route path="/lifeLongReq" element={<LifeLongForm />} />

         <Route path="/sanghaFundReq" element={<SanghaFundForm />} />
         <Route path="/annualFundReq" element={<AnnualFundForm />} />



        <Route path="/annualarma" element={<AnnualArma />} />
        <Route path="/ceramonyvideo" element={<CeramonyVideo />} />
        <Route path="/selectDay" element={<SelectDay />} />
        <Route path="/securespot" element={<Securespot />} />

        <Route path="/aramaPoojaRequest" element={<AramaPoojaRequest />} />
        <Route path="/landLotRequest" element={<LandLotRequest />} />
        <Route path="/fiveYearRequest" element={<FiveYearRequest />} />
        <Route
          path="/membershopforfiveyear"
          element={<MembershipForFiveYear />}
        />

        <Route path="externalRetreats" element={<ExternalRetreats />} />
        <Route path="guestspeakers" element={<GuestSpeaker />} />
        <Route path="ordination" element={<Ordination />} />
        <Route path="/internalRetreats" element={<InternalRetreats />} />
        <Route path="/itemBring" element={<ItemsToBring />} />
        <Route path="/timeTabel" element={<TimeTable />} />
        <Route path="/internalRules" element={<InternalRules />} />
        <Route path="/soloRetreat" element={<SoloRetreat />} />
        <Route path="/organiserInstructions" element={<OrganiserInstructions />} />
        <Route path="/OrgainserRegister" element={<OrgainserRegister />} />



        <Route path="/InternalRetreatOrganiser" element={<InternalRetreatOrganiser />} />

        <Route
          path="/externalRetreatPackenham"
          element={<ExternalRetreatPackenham />}
        />
        <Route
          path="/externalRetreatHallam"
          element={<ExternalRetreatHallam />}
        />
        <Route path="/externalRetreatGlen" element={<ExternalRetreatGlen />} />
        <Route path="/organizerRequestForm" element={<GuestSpeakerOrgReq />} />
        <Route path="/internalRetreatForm" element={<InternalRetreatForm />} />

        <Route
          path="/internalRetreatRequest"
          element={<InternalRetreatRequestForm />}
        />
        <Route path="/guestSpeakerRequest" element={<GuestSpeakerRequest />} />
        <Route
          path="/soloRetreatRegistration"
          element={<SoloRetreatRegistrationForm />}
        />
        <Route path="/soloRequest" element={<SoloRetreatRequestForm />} />

        <Route
          path="/ordinationRegistration"
          element={<OrdinationRegistration />}
        />
        <Route path="/ordinationRequest" element={<OrdinationRequest />} />

        <Route path="/exRules" element={<ExternalRules />} />
        <Route
          path="/organizerInstructions"
          element={<OrganizerInstructions />}
        />

        <Route path="/ongoingProjects" element={<OngoingProjects />} />
        <Route path="/futurePlans" element={<FeaturePlans />} />
        <Route
          path="/maintenanceHermitage"
          element={<MaintenanceHermitage />}
        />
        <Route path="/onGoingRequest" element={<OnGoingRequest />} />
        <Route path="/featureplansrequest" element={<FeaturePlanRequest />} />
        <Route path="/maintananceRequest" element={<MaintananceRequest />} />

        <Route path="/photoGallery" element={<PhotoGallery />} />
        <Route path="/generalForm" element={<GeneralForm />} />


        <Route path="/" element={<Home />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/admin/*" element={<DashboardRoutes />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;